import { useEffect, useState } from 'react';
import { Box, Card, CardContent, Grid, IconButton, Typography } from '@mui/material';
import { toast } from 'react-toastify';

import CommonPageAddDocument from 'components/common_page_data/CommonPageAddDocument';
import Breadcrumb from 'components/ui/Breadcrumb';
import { getCommonPageDataAssetsRequest, saveCommonPageDataAssetsRequest, deleteFolderAssetRequest } from 'services/common_page_data';
import { useParams } from 'react-router-dom';
import { Delete } from '@mui/icons-material';

const CommonPageDataEdit = () => {
    const [folderAssetsMutation, setFolderAssetsMutation] = useState({});
    const [folderAssetsLoading, setFoldersAssetsLoading] = useState(true);
    const [folderImages, setFolderImages] = useState([]);
    const [folderDocuments, setFolderDocuments] = useState([]);

    const params = useParams();

    const handleAddAssets = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        if (values?.image?.key || values?.document?.key) {
            const result = await saveCommonPageDataAssetsRequest({
                folderId: params.id,
                folderImage: values?.image?.key ? values?.image?.key : null,
                folderDocument: values?.document?.key ? values?.document?.key : null
            });
            if (result.error === false) {
                setFolderAssetsMutation({});
                resetForm();
            }
        } else {
            toast.error('Please select an image or document to upload');
        }
        setSubmitting(false);
    };

    const handleAssetDelete = async (assetId) => {
        const result = await deleteFolderAssetRequest(params.id, assetId);
        if (result.error === false) {
            setFolderAssetsMutation({});
        }
    };

    useEffect(() => {
        async function fetchCommonPageDataStatus() {
            setFoldersAssetsLoading(true);
            const response = await getCommonPageDataAssetsRequest(params.id);
            if (response.error === false) {
                response?.commonPageFolder?.commonPageAssets?.map((ele) => {
                    if (ele._id === 'DOC') {
                        setFolderDocuments(ele?.data ?? []);
                    }
                    if (ele._id === 'IMAGE') {
                        let images = ele?.data ?? [];
                        const baseUrl = response?.imageBaseUrl ?? '';
                        images = images.map((imageObj) => ({
                            ...imageObj,
                            image: `${baseUrl}${imageObj.folderValue}`
                        }));
                        setFolderImages(images);
                    }

                    return ele;
                });
            }
            setFoldersAssetsLoading(false);
        }

        fetchCommonPageDataStatus();
    }, [folderAssetsMutation]);

    return (
        <>
            <Breadcrumb title="Update Common Page" />

            <Card>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <CommonPageAddDocument handleSubmit={handleAddAssets} />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Card sx={{ mt: 3 }}>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h4">Folder Images</Typography>
                        </Grid>

                        <Grid item xs={12} mt={2}>
                            {folderAssetsLoading ? (
                                <Typography>Loading...</Typography>
                            ) : (
                                <Grid container spacing={2}>
                                    {folderImages.map((imageObj) => (
                                        <Grid item xs={12} md={4}>
                                            <Box
                                                style={{
                                                    width: '100%',
                                                    height: '15rem',
                                                    position: 'relative'
                                                }}
                                            >
                                                <img
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover'
                                                    }}
                                                    src={imageObj?.image}
                                                    alt=""
                                                />
                                                <IconButton
                                                    onClick={() => handleAssetDelete(imageObj._id)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 5,
                                                        right: 5
                                                    }}
                                                >
                                                    <Delete color="error" />
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Card sx={{ mt: 3 }}>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h4">Folder Documents</Typography>
                        </Grid>

                        <Grid item xs={12} mt={2}>
                            {folderAssetsLoading ? (
                                <Typography>Loading...</Typography>
                            ) : (
                                <Grid container spacing={5}>
                                    {folderDocuments.map((folderObj) => (
                                        <Grid item xs={13} md={4}>
                                            <Card sx={{ bgcolor: '#fafafa', border: '1px solid rgba(0, 0, 0, 0.12)' }}>
                                                <CardContent>
                                                    <Grid container sx={{ alignItems: 'center' }}>
                                                        <Grid xs={11} item>
                                                            {folderObj.folderValue.split('/docs/')[1]}
                                                        </Grid>

                                                        <Grid xs={1} item>
                                                            <IconButton onClick={() => handleAssetDelete(folderObj._id)}>
                                                                <Delete color="error" />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
};

export default CommonPageDataEdit;
